import { Flag16Filled } from '@fluentui/react-icons';

import { CardData } from 'src/models/CardActivities/CardData';
import { SpotlightLayoutType, MediaType, ApplicationSource } from 'src/utils/enums';

import SpotlightCardContent, { SpotlightContent } from '../spotlight-card-content/SpotlightCardContent';

interface RightSideVideoSpotlightProps {
  card: CardData
}

const RightSideVideoSpotlight: React.FC<RightSideVideoSpotlightProps> = ({
  card,
}: RightSideVideoSpotlightProps) => {
  const templateData = card.templateData;
  if (!templateData) return null;

  const bodyHeader
    = card.sourceApplication === ApplicationSource.HealthAssessment
      ? `Take the ${templateData.headline}`
      : templateData.headline;

  const content: SpotlightContent = {
    headline: templateData.sSkyHeadline,
    body: templateData.body,
    badgeIcon: templateData.sSkyHeadline ? <Flag16Filled /> : undefined,
    callToAction: templateData.callToAction,
    actionURL: templateData.actionURL,
    videoId: templateData.sSkyVideoId,
    bodyHeader: bodyHeader,
    videoPoster: templateData.sSkyPoster || templateData.image,
    // TODO: Remove hard code for mediaUrl, the video Url will be constructed from videoId
    mediaUrl: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    mediaType: MediaType.VIDEO,
  };

  return (
    <div data-testid="right-side-video-spotlight">
      <SpotlightCardContent content={content} layoutType={SpotlightLayoutType.TEXT_LEFT_MEDIA_RIGHT} />
    </div>
  );
};

export default RightSideVideoSpotlight;
